import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useRoute } from '@nuxtjs/composition-api';
import { pluralize } from '@/plugins/filters';

type PublicPortfolioHeroConnectionsProps = {
  connectionsCount: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioHeroConnections',
  props: {
    connectionsCount: null
  },
  setup(__props: any) {

const props = __props as {
  connectionsCount: number;
};


const { $analytics, $utils, $pages } = useContext();
const route = useRoute();

const buttonWording = computed(() =>
  props.connectionsCount === 0
    ? 'No connections yet'
    : `${props.connectionsCount} ${pluralize(props.connectionsCount, 'Connection')}`,
);

function showConnections() {
  $analytics?.logEvent('public-portfolio__connections__click');
  $utils.redirectWithQuery($pages.PORTFOLIO_SLUG_CONNECTIONS_PAGE, {
    params: { slug: route.value.params.slug },
  });
}

return { __sfc: true,props, $analytics, $utils, $pages, route, buttonWording, showConnections }
}

})